import _ from 'lodash';
import parser from 'ua-parser-js';
import Api from '@/api';
import * as types from '../mutation-types';

const state = {
  offcanve: false,
  trackID: '',
  language: 'zh_HK',
  currency: 'HKD',
  region: '',
  // 服务器时间和用户时间差
  timeDiff: null,
  openOffCanvas: false,
  offCanvasActive: false,
  searchToolOpened: false,
  fromRoute: {},
  searchKeyword: '',
  searchPlatform: 'local',
  languages: {
    zh_HK: {
      lang: 'zh_HK',
      label: '繁體中文',
    },
    zh_CN: {
      lang: 'zh_CN',
      label: '简体中文',
    },
    en: {
      lang: 'en',
      label: 'English',
    },
    // fr: {
    //   lang: 'fr',
    //   label: 'France',
    // },
    // ja: {
    //   lang: 'ja',
    //   label: '日本語',
    //   flag: jpFlag,
    // },
  },
  states: [
    {
      title: 'state.africa_middle_east_and_india',
      zones: [
        {
          name: 'Armenia',
          code: 'AM',
          codes: '亚美尼亚',
        },
        {
          name: 'البحرين',
          code: 'BH',
          codes: '巴林',
        },
        {
          name: 'Botswana',
          code: 'BW',
          codes: '博茨瓦纳',
        },
        {
          name: 'Cameroun',
          code: 'CM',
          codes: '喀麦隆',
        },
        {
          name: 'République Centrafricaine',
          code: 'CF',
          codes: '中非共和国',
        },
        {
          name: 'Côte d\'Ivoire',
          code: 'CI',
          codes: '象牙海岸',
        },
        {
          name: 'مصر',
          code: 'EG',
          codes: '埃及',
        },
        {
          name: 'Guinea-Bissau',
          code: 'GW',
          codes: '几内亚比绍',
        },
        {
          name: 'Guinée',
          code: 'GN',
          codes: '几内亚',
        },
        {
          name: 'Guinée Equatoriale',
          code: 'GQ',
          codes: '赤道几内亚',
        },
        {
          name: 'India',
          code: 'IN',
          codes: '印度',
        },
        {
          name: 'Israel',
          code: 'IL',
          codes: '以色列',
        },
        {
          name: 'الأردن',
          code: 'JO',
          codes: '',
        },
        {
          name: 'Kenya',
          code: 'KE',
          codes: '肯尼亚',
        },
        {
          name: 'الكويت',
          code: 'KW',
          codes: '科威特',
        },
        {
          name: 'Madagascar',
          code: 'MG',
          codes: '马达加斯加',
        },
        {
          name: 'Mali',
          code: 'ML',
          codes: '马里共和国',
        },
        {
          name: 'Maroc',
          code: 'MA',
          codes: '摩洛哥',
        },
        {
          name: 'Maurice',
          code: 'MU',
          codes: '毛里求斯',
        },
        {
          name: 'Mozambique',
          code: 'MZ',
          codes: '莫桑比克',
        },
        {
          name: 'Niger',
          code: 'NE',
          codes: '尼日尔',
        },
        {
          name: 'Nigeria',
          code: 'NG',
          codes: '尼日利亚',
        },
        {
          name: 'عُمان',
          code: 'OM',
          codes: '阿曼',
        },
        {
          name: 'قطر',
          code: 'QA',
          codes: '卡塔尔',
        },
        {
          name: 'المملكة العربية السعودية',
          code: 'SA',
          codes: '沙特阿拉伯王国',
        },
        {
          name: 'Sénégal',
          code: 'SN',
          codes: '塞内加尔',
        },
        {
          name: 'South Africa',
          code: 'ZA',
          codes: '南非',
        },
        {
          name: 'Tunisie',
          code: 'TN',
          codes: '突尼斯',
        },
        {
          name: 'Uganda',
          code: 'UG',
          codes: '烏干達',
        },
        {
          name: 'الإمارات العربية المتحدة',
          code: 'AE',
          codes: '阿聯酋',
        },
      ],
    },
    {
      title: 'state.asia_pacific',
      zones: [
        {
          name: 'Australia',
          code: 'AU',
          codes: '澳大利亞',
        },
        {
          name: '中国大陆',
          code: 'CN',
          codes: '中國大陸',
        },
        {
          name: '香港',
          code: 'HK',
          codes: '香港',
        },
        {
          name: 'Indonesia',
          code: 'ID',
          codes: '印度尼西亞',
        },
        {
          name: '日本',
          code: 'JP',
          codes: '日本',
        },
        {
          name: '대한민국',
          code: 'KR',
          codes: '韓國',
        },
        {
          name: '澳門',
          code: 'MO',
          codes: '澳門',
        },
        {
          name: 'Malaysia',
          code: 'MY',
          codes: '馬來西亞',
        },
        {
          name: 'New Zealand',
          code: 'NZ',
          codes: '新西蘭',
        },
        {
          name: 'Philippines',
          code: 'PH',
          codes: '菲律賓',
        },
        {
          name: 'Singapore',
          code: 'SG',
          codes: '新加坡',
        },
        {
          name: '台灣',
          code: 'TW',
          codes: '台灣',
        },
        {
          name: 'ไทย',
          code: 'TH',
          codes: '泰國',
        },
        {
          name: 'Vietnam',
          code: 'VN',
          codes: '越南',
        },
      ],
    },
    {
      title: 'state.europe',
      zones: [
        {
          name: 'België',
          code: 'BE',
          codes: '比利時',
        },
        {
          name: 'България',
          code: 'BG',
          codes: '保加利亞',
        },
        {
          name: 'Česko',
          code: 'CZ',
          codes: '捷克',
        },
        {
          name: 'Danmark',
          code: 'DK',
          codes: '丹麥',
        },
        {
          name: 'Deutschland',
          code: 'DE',
          codes: '德國',
        },
        {
          name: 'Eesti',
          code: 'EE',
          codes: '愛沙尼亞',
        },
        {
          name: 'España',
          code: 'ES',
          codes: '西班牙',
        },
        {
          name: 'France',
          code: 'FR',
          codes: '法國',
        },
        {
          name: 'Ελλάδα',
          code: 'GR',
          codes: '希臘',
        },
        {
          name: 'Hrvatska',
          code: 'HR',
          codes: '克羅地亞',
        },
        {
          name: 'Ireland',
          code: 'IE',
          codes: '愛爾蘭',
        },
        {
          name: 'Italia',
          code: 'IT',
          codes: '意大利',
        },
        {
          name: 'Latvija',
          code: 'LV',
          codes: '拉脫維亞',
        },
        {
          name: 'Liechtenstein',
          code: 'LI',
          codes: '列支敦士登',
        },
        {
          name: 'Lietuva',
          code: 'LT',
          codes: '立陶宛',
        },
        {
          name: 'Luxembourg',
          code: 'LU',
          codes: '盧森堡',
        },
        {
          name: 'Macedonia',
          code: 'MK',
          codes: '馬其頓',
        },
        {
          name: 'Magyarország',
          code: 'HU',
          codes: '匈牙利',
        },
        {
          name: 'Malta',
          code: 'MT',
          codes: '馬耳他',
        },
        {
          name: 'Moldova',
          code: 'MD',
          codes: '摩爾達維亞',
        },
        {
          name: 'Montenegro',
          code: 'ME',
          codes: '黑山',
        },
        {
          name: 'Nederland',
          code: 'NL',
          codes: '荷蘭',
        },
        {
          name: 'Norge',
          code: 'NO',
          codes: '挪威',
        },
        {
          name: 'Österreich',
          code: 'AT',
          codes: '奧地利',
        },
        {
          name: 'Polska',
          code: 'PL',
          codes: '波蘭',
        },
        {
          name: 'Portugal',
          code: 'PT',
          codes: '葡萄牙',
        },
        {
          name: 'România',
          code: 'RO',
          codes: '羅馬尼亞',
        },
        {
          name: 'Россия',
          code: 'RU',
          codes: '俄羅斯',
        },
        {
          name: 'Slovensko',
          code: 'SK',
          codes: '斯洛伐克',
        },
        {
          name: 'Slovenia',
          code: 'SI',
          codes: '斯洛文尼亞',
        },
        {
          name: 'Schweiz',
          code: 'CH',
          codes: '瑞士',
        },
        {
          name: 'Suomi',
          code: 'FI',
          codes: '芬蘭',
        },
        {
          name: 'Sverige',
          code: 'SE',
          codes: '瑞典',
        },
        {
          name: 'Türkiye',
          code: 'TR',
          codes: '土耳其',
        },
        {
          name: 'UK',
          code: 'GB',
          codes: '英國',
        },
      ],
    },
    {
      title: 'state.latin_america_and_the_caribbean',
      zones: [
        {
          name: 'Anguilla',
          code: 'AI',
          codes: '安圭拉',
        },
        {
          name: 'Antigua & Barbuda',
          code: 'AG',
          codes: '安提瓜和巴布達',
        },
        {
          name: 'Argentina',
          code: 'AR',
          codes: '阿根廷',
        },
        {
          name: 'Barbados',
          code: 'BB',
          codes: '巴巴多斯',
        },
        {
          name: 'Belize',
          code: 'BZ',
          codes: '伯利茲',
        },
        {
          name: 'Bermuda',
          code: 'BM',
          codes: '百慕大',
        },
        {
          name: 'Bolivia',
          code: 'BO',
          codes: '玻利維亞',
        },
        {
          name: 'Brasil',
          code: 'BR',
          codes: '巴西',
        },
        {
          name: 'British Virgin Islands',
          code: 'VG',
          codes: '英屬維爾京群島',
        },
        {
          name: 'Cayman Islands',
          code: 'KY',
          codes: '開曼群島',
        },
        {
          name: 'Chile',
          code: 'CL',
          codes: '智利',
        },
        {
          name: 'Colombia',
          code: 'CO',
          codes: '哥倫比亞',
        },
        {
          name: 'República Dominicana',
          code: 'DO',
          codes: '多米尼加共和國',
        },
        {
          name: 'Ecuador',
          code: 'EC',
          codes: '厄瓜多爾',
        },
        {
          name: 'Grenada',
          code: 'GD',
          codes: '格林納達',
        },
        {
          name: 'Guatemala',
          code: 'GT',
          codes: '危地馬拉',
        },
        {
          name: 'Guyana',
          code: 'GY',
          codes: '圭亞那',
        },
        {
          name: 'Honduras',
          code: 'HN',
          codes: '洪都拉斯',
        },
        {
          name: 'Jamaica',
          code: 'JM',
          codes: '牙買加',
        },
        {
          name: 'México',
          code: 'MX',
          codes: '墨西哥',
        },
        {
          name: 'Montserrat',
          code: 'MS',
          codes: '蒙特塞拉特',
        },
        {
          name: 'Nicaragua',
          code: 'NI',
          codes: '尼加拉瓜',
        },
        {
          name: 'Panamá',
          code: 'PA',
          codes: '巴拿馬',
        },
        {
          name: 'Paraguay',
          code: 'PY',
          codes: '巴拉圭',
        },
        {
          name: 'Perú',
          code: 'PE',
          codes: '秘魯',
        },
        {
          name: 'St. Kitts & Nevis',
          code: 'KN',
          codes: '聖基茨和尼維斯',
        },
        {
          name: 'St. Lucia',
          code: 'LC',
          codes: '聖聖盧西亞',
        },
        {
          name: 'St. Vincent & The Grenadines',
          code: 'VC',
          codes: '聖文森特和格林納丁斯',
        },
        {
          name: 'Suriname',
          code: 'SR',
          codes: '蘇里南',
        },
        {
          name: 'The Bahamas',
          code: 'BS',
          codes: '巴哈馬群島',
        },
        {
          name: 'Trinidad & Tobago',
          code: 'TT',
          codes: '特立尼達和多巴哥',
        },
        {
          name: 'Turks & Caicos',
          code: 'TC',
          codes: '特克斯和凱科斯群島',
        },
        {
          name: 'Uruguay',
          code: 'UY',
          codes: '烏拉圭',
        },
        {
          name: 'Venezuela',
          code: 'VE',
          codes: '委內瑞拉',
        },
      ],
    },
    {
      title: 'state.the_united_states_canada_and_puerto_rico',
      zones: [
        {
          name: 'Canada',
          code: 'CA',
          codes: '加拿大',
        },
        {
          name: 'Puerto Rico',
          code: 'PR',
          codes: '波多黎各',
        },
        {
          name: 'United States',
          code: 'US',
          codes: '美國',
        },
      ],
    },
  ],
  platforms: [
    {
      label: '全部',
      value: 'all',
    },
    {
      label: 'Okubuy',
      value: 'local',
    },
    {
      label: 'Rakuten',
      value: 'rakuten',
    },
    {
      label: 'YAHOO!JAPAN',
      value: 'yahoo_jp',
    },
    {
      label: 'Amazon Japan',
      value: 'amazon_jp',
    },
  ],
  userAgent: {
    browser: null,
    cpu: null,
    device: null,
    engine: null,
    os: null,
    ua: '',
  },
};

const getters = {
  isMobile: s => s.userAgent.device && s.userAgent.device.type === 'mobile',
  isTablet: s => s.userAgent.device && s.userAgent.device.type === 'tablet',
  regionsNames: (s) => {
    const names = {};
    const zones = _.flatten(_.map(s.states, 'zones'));
    zones.forEach((zone) => {
      names[zone.code] = [zone.name, zone.codes];
    });
    return names;
  },
};

const actions = {
  setTrackId({ commit }, val) {
    commit(types.SET_TRACK_ID, val);
  },
  setLanguage({ commit }, language) {
    if (language === 'zh_TW') {
      language = 'zh_HK';
    }
    const saved = localStorage.getItem('language');
    commit(types.SET_LANGUAGE, language);
    localStorage.setItem('language', language);
    if (saved !== language) {
      if (saved !== null) {
        // 没有保存不刷新
        localStorage.setItem('refresh-cache', Date.now());
      }
      return Promise.resolve();
    }
    return Promise.reject();
  },
  setCurrency({ commit }) {
    return Api.app.currency().then(({ data: response }) => {
      commit(types.SET_CURRENCY, response.currency);
    });
  },
  setRegion({ commit }, { region = 'HK', save = true }) {
    const saved = localStorage.getItem('region');
    commit(types.SET_REGION, region);
    if (save) {
      localStorage.setItem('region', region);
    }
    if (saved !== region) {
      if (saved !== null) {
        // 没有保存不刷新
        localStorage.setItem('refresh-cache', Date.now());
      }
      return Promise.resolve();
    }
    return Promise.reject();
  },
  setTimeDiff({ commit }, val) {
    commit(types.SET_TIMESTAMP_DIFF, val);
  },
  offCanvasOpen({ state, commit }) {
    state.offcanve = true;
    commit(types.SET_OPEN_OFF_CANVAS, true);
    commit(types.SET_OFF_CANVAS_ACTIVE, true);
  },
  offCanvasClose({ state, commit }) {
    state.offcanve = false;
    commit(types.SET_OPEN_OFF_CANVAS, false);
    setTimeout(() => {
      commit(types.SET_OFF_CANVAS_ACTIVE, false);
    });
  },
  searchToolOpen({ commit }) {
    commit(types.SET_SEARCH_TOOL_OPENED, true);
  },
  searchToolClose({ commit }) {
    commit(types.SET_SEARCH_TOOL_OPENED, false);
  },
  uaParse({ commit }) {
    const result = parser();
    commit('setParseResult', result);
  },
  setFromRoute({ commit }, route) {
    commit(types.SET_FROM_ROUTE, route);
  },
};

/* eslint no-param-reassign: 0, no-shadow: 0 */
const mutations = {
  [types.SET_TRACK_ID](s, val) {
    s.trackID = val;
  },
  [types.SET_LANGUAGE](s, language) {
    s.language = language;
  },
  [types.SET_CURRENCY](s, currency) {
    s.currency = currency;
  },
  [types.SET_REGION](s, region) {
    s.region = region;
  },
  [types.SET_TIMESTAMP_DIFF](s, val) {
    s.timeDiff = val;
  },
  [types.SET_OPEN_OFF_CANVAS](s, val) {
    s.openOffCanvas = val;
  },
  [types.SET_OFF_CANVAS_ACTIVE](s, val) {
    s.offCanvasActive = val;
  },
  [types.SET_SEARCH_TOOL_OPENED](s, val) {
    s.searchToolOpened = val;
  },
  [types.SET_FROM_ROUTE](s, route) {
    s.fromRoute = route;
  },
  [types.SET_SEARCH_KEYWORD](s, val) {
    s.searchKeyword = val;
  },
  [types.SET_SEARCH_PLATFORM](s, val) {
    s.searchPlatform = val;
  },
  setParseResult(s, result) {
    s.userAgent.browser = result.browser;
    s.userAgent.cpu = result.cpu;
    s.userAgent.device = result.device;
    s.userAgent.engine = result.engine;
    s.userAgent.os = result.os;
    s.userAgent.ua = result.ua;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
